import { ModelBase } from "../abstract/model-base.model";
import { AnalyticalAxis } from "./analytical-axis.model";
import { AnalyticalSection } from "./analytical-section.model";

export class AnalyticalDistributionSection extends ModelBase {

    static override CLASS_NAME: string = 'AnalyticalDistributionSection';

    private _axis!: AnalyticalAxis;
    private _section!: AnalyticalSection;

    public get axis(): AnalyticalAxis {
        return this._axis;
    }

    public set axis(value: any) {
        this._setValue('_axis', value, 'AnalyticalAxis');
    }

    public get section(): AnalyticalSection {
        return this._section;
    }

    public set section(value: any) {
        this._setValue('_section', value, 'AnalyticalSection');
    }
}
